import { prepareRequest, SettingsManager } from '@apollo/core'

export const getActiveForms = (options) => {
  const request = prepareRequest({
    url: 'client/form:get-active-forms',
    method: 'GET',
    query: options
  })

  return request()
}

export const createPayment = async (paymentOptions) => {
  try {
    paymentOptions.amount = Number.parseInt(
      paymentOptions.amount || paymentOptions.chargetotal
    )
  } catch (e) {
    paymentOptions.amount = 1000
  }

  const request = prepareRequest({
    url: 'payment/deposits:create',
    method: 'POST',
    headers: {
      lang: SettingsManager.getSettings().lang
    }
  })

  return request(paymentOptions)
}

export const createWithdrawal = async (options) => {
  try {
    options.amount = Number.parseInt(options.amount)
  } catch (e) {
    options.amount = 1000
  }

  const request = prepareRequest({
    url: 'payment/withdrawals:create',
    method: 'POST'
  })

  return request(options)
}

export const getCredentials = async (options) => {
  const request = prepareRequest({
    url: 'payment/client-meta/saved-credentials:get',
    method: 'POST'
  })

  return request(options)
}

export const deleteCredentials = async (options) => {
  const request = prepareRequest({
    url: 'payment/client-meta/saved-credentials:delete',
    method: 'POST'
  })

  return request(options)
}

export const passwordResetWithForm = async (data) => {
  const { id, resetToken, ...values } = data

  const request = prepareRequest({
    url: 'client/clients:passwordReset-with-form',
    method: 'POST'
  })

  return request({ id, resetToken, values })
}
